import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
/* CORE */
import app from './routes/app'
/* ADMIN:CORE */
import users from './routes/Core/Users'
import userTypes from './routes/Core/User_types'
import appConfig from './routes/Core/Configs'
import branches from './routes/Core/Branches'
/* ADMIN:APP */
import carousel from './routes/App/Carousel'
import categories from './routes/App/Categories'
import feedbacks from './routes/App/Feedbacks'
import notifications from './routes/App/Notifications'
import products from './routes/App/Products'
import qrCodes from './routes/App/QrCodes'
import socialMedia from './routes/App/SocialMedia'
import welcome from './routes/App/Welcome'
import reports from './routes/App/Reports'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...app,
    ...appConfig,
    ...branches,
    ...userTypes,
    ...users,
    ...carousel,
    ...categories,
    ...feedbacks,
    ...notifications,
    ...products,
    ...qrCodes,
    ...socialMedia,
    ...welcome,
    ...reports,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
